/* ============================================================
   HYRALUXE PLP — filter drawer, price range, LOAD MORE.

   The filtering itself is Shopify's: the drawer is a real GET form against the
   collection URL, so the results, the counts and the chips all come from one
   render. What is left here is the furniture — the accordions, the dual-handle
   price slider, and appending the next page in place.
   ============================================================ */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---------------- Filter group accordions ---------------- */
  document.addEventListener('click', e => {
    const head = e.target.closest('.filter-group__head');
    if (!head) return;
    const group = head.parentElement;
    group.classList.toggle('open');
    head.setAttribute('aria-expanded', String(group.classList.contains('open')));
  });

  /* ---------------- Dual-handle price range ----------------
     Two stacked range inputs. The low handle can never cross the high one, and
     the filled band between them is painted from their live values. */
  $$('[data-range]').forEach(wrap => {
    const lo = $('#range-min', wrap);
    const hi = $('#range-max', wrap);
    const fill = $('.range-fill', wrap);
    const loLabel = $('#price-lo');
    const hiLabel = $('#price-hi');
    if (!lo || !hi) return;

    const cap = +wrap.dataset.cap || +hi.max || 100;

    const paint = () => {
      let a = +lo.value, b = +hi.value;
      if (a > b) { const t = a; a = b; b = t; }
      const left = (a / cap) * 100;
      const right = (b / cap) * 100;
      if (fill) { fill.style.left = left + '%'; fill.style.width = (right - left) + '%'; }
      if (loLabel) loLabel.textContent = '₹' + a.toLocaleString('en-IN');
      if (hiLabel) hiLabel.textContent = '₹' + b.toLocaleString('en-IN');
    };

    lo.addEventListener('input', () => {
      if (+lo.value > +hi.value) lo.value = hi.value;
      paint();
    });
    hi.addEventListener('input', () => {
      if (+hi.value < +lo.value) hi.value = lo.value;
      paint();
    });
    paint();
  });

  /* ---------------- Drop empty fields before submitting ----------------
     An unticked checkbox submits nothing, but an untouched price slider would
     submit its full range and pin a "₹0–₹2,000" chip to a page that is not
     filtered at all. */
  const form = $('[data-filter-form]');
  if (form) {
    form.addEventListener('submit', () => {
      const lo = $('#range-min', form);
      const hi = $('#range-max', form);
      if (lo && hi) {
        const cap = +hi.max;
        if (+lo.value === 0) lo.disabled = true;
        if (+hi.value === cap) hi.disabled = true;
      }
    });
  }

  /* ---------------- LOAD MORE ----------------
     Fetches the next page and appends its cards, so the position on the page is
     kept. The button is a real link, so it still works with no JS at all. */
  const more = $('[data-loadmore]');
  if (more) {
    let busy = false;
    more.addEventListener('click', async e => {
      if (!more.href) return;
      e.preventDefault();
      if (busy) return;
      busy = true;
      more.classList.add('is-busy');
      more.textContent = 'LOADING…';
      try {
        const res = await fetch(more.href);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const grid = $(more.dataset.grid || '#cgrid');
        const fresh = doc.querySelector(more.dataset.grid || '#cgrid');
        if (grid && fresh) grid.insertAdjacentHTML('beforeend', fresh.innerHTML);

        const info = $(more.dataset.info || '#cinfo');
        const freshInfo = doc.querySelector(more.dataset.info || '#cinfo');
        /* The next page reports only its own slice ("Showing 13–24 of 27"),
           but after appending the shopper is looking at everything from 1. */
        if (info && freshInfo) info.textContent = freshInfo.textContent.replace(/Showing\s+\d+\s*[–-]/, 'Showing 1–');

        /* Read the attribute, never the resolved `.href`: an <a href="">
           reports the current document's URL, which reads as a real next page
           and sends the next click round to fetch the same page again. */
        const freshMore = doc.querySelector('[data-loadmore]');
        const nextHref = freshMore ? (freshMore.getAttribute('href') || '').trim() : '';
        if (nextHref) {
          more.href = new URL(nextHref, window.location.origin).href;
          more.textContent = 'LOAD MORE';
          more.classList.remove('is-busy');
        } else {
          more.remove();
        }

        /* newly appended hearts have to learn what is already saved */
        if (window.hyraPaintHearts) window.hyraPaintHearts();
        busy = false;
        more.dispatchEvent(new Event('loadmore:done'));
      } catch (err) {
        busy = false;
        more.textContent = 'LOAD MORE';
        more.classList.remove('is-busy');
        if (window.hyraToast) window.hyraToast('Could not load more right now.');
      }
    });

    /* Load the next page on its own as the shopper scrolls near the end, so
       the list simply continues. The button stays as the fallback and for
       anyone without IntersectionObserver. */
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => {
        /* "near" also counts a button already scrolled past — a fast fling
           can carry the shopper beyond it while the previous page loads. */
        const e = entries[0];
        if ((e.isIntersecting || e.boundingClientRect.top < 0) && more.isConnected) more.click();
        if (!more.isConnected) io.disconnect();
      }, { rootMargin: '0px 0px 600px 0px' });
      io.observe(more);
      /* After a page lands the button can still sit inside the margin, and an
         observer only reports changes — so look again from scratch. */
      more.addEventListener('loadmore:done', () => { io.unobserve(more); io.observe(more); });
    }
  }
})();
